import ui from 'photoswipe/dist/photoswipe-ui-default';
import Photoswipe from 'photoswipe';

class PhotoswipeGallery {
  constructor(thumnailsRootElement) {
    this.items = [];
    this.galleryRootElement = document.getElementById('photoswipe-root');
    this.thumnailsRootElement = thumnailsRootElement;
  }

  addItem(item) {
    this.items.push(item);
  }

  updateItem(item) {
    const found = this.items.find((i) => i.src === item.src);
    if (found) {
      Object.assign(found, item);

      if (this.gallery) {
        this.gallery.invalidateCurrItems();
        this.gallery.updateSize(true);
      }
    }
  }

  open(index) {
    const options = {
      index,
      history: false,
      showHideOpacity: true,
      shareButtons: [
        {
          id: 'download',
          label: 'Download original image',
          url: '{{raw_image_url}}',
          download: true,
        },
      ],
      // uncomment the following to disable animation
      // hideAnimationDuration: 0,
      // showAnimationDuration: 0,
      getThumbBoundsFn: (itemIndex) => {
        const boundingElement = this.thumnailsRootElement.querySelectorAll('img')[itemIndex];
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const pageXScroll = window.pageXOffset || document.documentElement.scrollLeft;
        const { left, top, width } = boundingElement.getBoundingClientRect();

        return {
          x: left + pageXScroll,
          y: top + pageYScroll,
          w: width,
        };
      },
    };

    this.gallery = new Photoswipe(this.galleryRootElement, ui, this.items, options);
    this.gallery.listen('close', () => {
      this.gallery = null;
    });

    this.gallery.init();
  }
}

export default PhotoswipeGallery;
